<div class="cover-design-items">
  @for (previewTheme of previewThemes(); track previewTheme.cover.design) {
    <div
      class="cover-design-item"
      [class.active]="theme().cover.design === previewTheme.cover.design"
      (click)="selectDesign(previewTheme.cover.design)"
    >
      <app-cover-design [gallery]="gallery()" [theme]="previewTheme"></app-cover-design>
      <div class="name">
        {{ previewTheme.cover.design }}
      </div>
    </div>
  }
</div>

@if (theme().cover.design) {
  <button
    appButton
    name="remove-cover-design"
    location="theme-cover-select-item"
    color="simple-warn"
    weight="bold"
    [center]="true"
    shape="round"
    height="1"
    (click)="selectDesign(null)"
    class="remove-design"
  >
    Remove Design
  </button>
}
